export const CONTACT_EMAIL = "info@talenthubofficial.it";

export const COUNTRIES = [
  { code: "IT", it: "Italia", en: "Italy", es: "Italia", de: "Italien" },
  { code: "AR", it: "Argentina", en: "Argentina", es: "Argentina", de: "Argentinien" },
  { code: "AT", it: "Austria", en: "Austria", es: "Austria", de: "Österreich" },
  { code: "AU", it: "Australia", en: "Australia", es: "Australia", de: "Australien" },
  { code: "BE", it: "Belgio", en: "Belgium", es: "Bélgica", de: "Belgien" },
  { code: "BR", it: "Brasile", en: "Brazil", es: "Brasil", de: "Brasilien" },
  { code: "CA", it: "Canada", en: "Canada", es: "Canadá", de: "Kanada" },
  { code: "CH", it: "Svizzera", en: "Switzerland", es: "Suiza", de: "Schweiz" },
  { code: "CL", it: "Cile", en: "Chile", es: "Chile", de: "Chile" },
  { code: "CO", it: "Colombia", en: "Colombia", es: "Colombia", de: "Kolumbien" },
  { code: "CZ", it: "Rep. Ceca", en: "Czech Republic", es: "República Checa", de: "Tschechien" },
  { code: "DE", it: "Germania", en: "Germany", es: "Alemania", de: "Deutschland" },
  { code: "DK", it: "Danimarca", en: "Denmark", es: "Dinamarca", de: "Dänemark" },
  { code: "EG", it: "Egitto", en: "Egypt", es: "Egipto", de: "Ägypten" },
  { code: "ES", it: "Spagna", en: "Spain", es: "España", de: "Spanien" },
  { code: "FR", it: "Francia", en: "France", es: "Francia", de: "Frankreich" },
  { code: "GB", it: "Regno Unito", en: "United Kingdom", es: "Reino Unido", de: "Vereinigtes Königreich" },
  { code: "GR", it: "Grecia", en: "Greece", es: "Grecia", de: "Griechenland" },
  { code: "HR", it: "Croazia", en: "Croatia", es: "Croacia", de: "Kroatien" },
  { code: "IE", it: "Irlanda", en: "Ireland", es: "Irlanda", de: "Irland" },
  { code: "JP", it: "Giappone", en: "Japan", es: "Japón", de: "Japan" },
  { code: "KR", it: "Corea del Sud", en: "South Korea", es: "Corea del Sur", de: "Südkorea" },
  { code: "MA", it: "Marocco", en: "Morocco", es: "Marruecos", de: "Marokko" },
  { code: "MX", it: "Messico", en: "Mexico", es: "México", de: "Mexiko" },
  { code: "NG", it: "Nigeria", en: "Nigeria", es: "Nigeria", de: "Nigeria" },
  { code: "NL", it: "Paesi Bassi", en: "Netherlands", es: "Países Bajos", de: "Niederlande" },
  { code: "NO", it: "Norvegia", en: "Norway", es: "Noruega", de: "Norwegen" },
  { code: "PL", it: "Polonia", en: "Poland", es: "Polonia", de: "Polen" },
  { code: "PT", it: "Portogallo", en: "Portugal", es: "Portugal", de: "Portugal" },
  { code: "RO", it: "Romania", en: "Romania", es: "Rumanía", de: "Rumänien" },
  { code: "RS", it: "Serbia", en: "Serbia", es: "Serbia", de: "Serbien" },
  { code: "SE", it: "Svezia", en: "Sweden", es: "Suecia", de: "Schweden" },
  { code: "SN", it: "Senegal", en: "Senegal", es: "Senegal", de: "Senegal" },
  { code: "TR", it: "Turchia", en: "Turkey", es: "Turquía", de: "Türkei" },
  { code: "UA", it: "Ucraina", en: "Ukraine", es: "Ucrania", de: "Ukraine" },
  { code: "US", it: "Stati Uniti", en: "United States", es: "Estados Unidos", de: "Vereinigte Staaten" },
  { code: "UY", it: "Uruguay", en: "Uruguay", es: "Uruguay", de: "Uruguay" },
  { code: "OTHER", it: "Altro", en: "Other", es: "Otro", de: "Andere" },
];

export const T = {
  it: {
    nav: {
      how: "Come Funziona",
      players: "Giocatori",
      scouts: "Scout",
      showcase: "Showcase",
      contact: "Contattaci",
      join: "Waitlist",
    },
    hero: {
      overline: "PRE-LANCIO // CALCIO GIOVANILE",
      line1: "DALLA TUA SOCIETÀ",
      line2: "AL GRANDE CALCIO.",
      sub: "La vetrina digitale riservata ai giovani calciatori tesserati. Carica i tuoi video highlights e fatti notare da talent scout e academy.",
      ctaPrimary: "Unisciti alla Waitlist",
      ctaSecondary: "Scrivici una mail",
      counterSuffix: "già in lista d'attesa",
      cardTag: "ROOKIE CARD // ANTEPRIMA",
      cardName: "IL PROSSIMO TALENTO",
      cardYou: "Potresti essere tu",
      cardChips: ["Ruolo —", "Età —", "Club —"],
    },
    marquee: "TALENT HUB • LA VETRINA DEL CALCIO GIOVANILE • SCOUTING DIGITALE • HIGHLIGHTS HD • TESSERATI & ACADEMY • FUTURE STARS • ",
    how: {
      overline: "IL PERCORSO",
      title: "Tre mosse verso il grande calcio",
      chapters: [
        {
          n: "01",
          title: "Tesseramento & Registrazione",
          body: "L'iscrizione è riservata ai giovani tesserati presso società sportive. Ogni profilo è reale, verificato, tracciabile.",
        },
        {
          n: "02",
          title: "Crea la tua vetrina",
          body: "Nome, cognome, età, società, ruolo, altezza — e soprattutto i tuoi video highlights: partite intere o le azioni che contano.",
        },
        {
          n: "03",
          title: "Fatti notare",
          body: "Talent scout e professionisti cercano nuovi talenti per giovanili e academy. La tua prossima chiamata parte da qui.",
        },
      ],
    },
    audiences: {
      overline: "DUE MONDI, UNA PIATTAFORMA",
      title: "Costruita per chi gioca e per chi osserva",
      tabPlayers: "Per i Giocatori",
      tabScouts: "Per gli Scout",
      playersTitle: "La tua vetrina. Il tuo talento.",
      playersBody: "Sei tesserato in una società sportiva? Talent Hub ti dà uno spazio professionale per mostrare chi sei, come giochi e perché conti.",
      playersBenefits: [
        "Profilo verificato: solo tesserati in società sportive",
        "Video highlights delle tue partite e azioni migliori",
        "Scheda completa: età, ruolo, altezza, società",
        "Visibilità diretta verso scout, academy e giovanili pro",
      ],
      scoutsTitle: "Il talento, prima degli altri.",
      scoutsBody: "Un feed curato di giovani già tesserati, con dati reali e video veri. Meno chilometri, più certezze.",
      scoutsBenefits: [
        "Filtri avanzati per età, ruolo, altezza e regione",
        "Video highlights HD per valutare il talento sul campo",
        "Contatto diretto con le società di appartenenza",
        "Feed di scouting sui talenti emergenti, sempre aggiornato",
      ],
    },
    showcase: {
      overline: "ANTEPRIMA PROFILO",
      title: "Così apparirà un talento",
      body: "Una mock card di esempio: dati, club e highlights in un unico colpo d'occhio.",
      watch: "Guarda highlights",
      save: "Salva profilo",
      saved: "Salvato",
      mockDisclaimer: "Profilo dimostrativo — i dati reali arriveranno con il lancio dell'app",
      modalTitle: "Highlights in arrivo",
      modalBody: "Con il lancio dell'app qui potrai vedere i video delle partite e delle azioni migliori di ogni talento.",
      close: "Chiudi",
    },
    highlights: {
      overline: "IN AZIONE",
      title: "Il calcio giovanile, come non l'hai mai visto.",
      body: "Un anticipo di come i talenti mostreranno le loro qualità su Talent Hub. Clicca su un video per vederlo intero.",
      disclaimer: "Video dimostrativi — i tuoi highlight reali saranno pubblicati al lancio.",
      clips: [
        { title: "Rovesciata in gol", tag: "Azione", src: "/videos/goal.mp4", poster: "/videos/goal-poster.jpg" },
        { title: "Dribbling di classe", tag: "Skill", src: "/videos/skill.mp4", poster: "/videos/skill-poster.jpg" },
        { title: "Uno contro uno", tag: "Tecnica", src: "/videos/dribble.mp4", poster: "/videos/dribble-poster.jpg" },
      ],
    },
    faq: {
      overline: "DOMANDE FREQUENTI",
      title: "Tutto quello che vuoi sapere prima di iscriverti.",
      body: "Le risposte alle domande più comuni su Talent Hub. Se hai altri dubbi, scrivici pure.",
      items: [
        {
          q: "Talent Hub sarà gratuito?",
          a: "Sì. L'iscrizione alla waitlist è gratuita, e la creazione del profilo base al lancio sarà gratuita per i giocatori. In futuro potremo introdurre funzioni premium opzionali (es. video HD extra, analytics avanzati), ma il cuore della piattaforma resterà accessibile a tutti.",
        },
        {
          q: "Come funziona il tesseramento?",
          a: "Talent Hub è riservato ai giovani già tesserati presso una società sportiva. In fase di registrazione ti chiederemo il nome del tuo club: verificheremo l'associazione con la società per garantire profili reali e proteggere sia i giocatori che gli scout.",
        },
        {
          q: "Come proteggete la privacy dei minori?",
          a: "Trattiamo i dati dei minori nel pieno rispetto del GDPR e della normativa italiana. Per gli under 14 richiediamo il consenso di un genitore o tutore. I profili non sono pubblici sul web: solo scout e società verificate potranno accedere ai contenuti attraverso la piattaforma.",
        },
        {
          q: "Chi può vedere il mio profilo e i miei video?",
          a: "Solo talent scout, società sportive e academy verificate da noi. Nessun profilo è indicizzato su Google e nessun contenuto viene condiviso all'esterno. Ogni giocatore (o il suo tutore) può decidere in qualsiasi momento chi può contattarlo e cosa mostrare.",
        },
        {
          q: "Come mi contattano gli scout?",
          a: "Gli scout interessati contattano prima la società sportiva di appartenenza, che a sua volta informa il giocatore o la famiglia. Non esiste contatto diretto senza filtro: la società rimane sempre al centro del processo, come nel calcio reale.",
        },
        {
          q: "Quando esce l'app?",
          a: "Stiamo raccogliendo interesse con questa waitlist prima di lanciare la versione ufficiale. Iscrivendoti sarai tra i primi a essere avvisato non appena l'app sarà live, e riceverai un accesso prioritario per creare il tuo profilo.",
        },
      ],
    },
    waitlist: {
      overline: "RESTA AGGIORNATO",
      title: "Sii tra i primi a scendere in campo",
      sub: "Lascia la tua email: ti avviseremo al lancio e ci aiuterai a capire l'interesse reale per Talent Hub.",
      emailPlaceholder: "La tua email",
      roleLabel: "Chi sei?",
      countryLabel: "Paese",
      roles: {
        player: "Calciatore",
        parent: "Genitore",
        scout: "Scout / Osservatore",
        club: "Società sportiva",
        other: "Altro",
      },
      submit: "Iscriviti ora",
      sending: "Invio in corso…",
      successTitle: "Sei dei nostri!",
      successBody: "Ti avviseremo appena Talent Hub sarà live. Nel frattempo, spargi la voce.",
      alreadyTitle: "Sei già in lista",
      alreadyBody: "Questa email è già registrata — ci vediamo al lancio!",
      invalid: "Inserisci un indirizzo email valido.",
      error: "Qualcosa è andato storto. Riprova tra poco.",
      copyLink: "Copia il link da condividere",
      copied: "Copiato!",
      contactAlt: "Preferisci scriverci direttamente?",
      counterLabel: "persone già in lista",
    },
    footer: {
      claim: "Il futuro del calcio giovanile inizia qui.",
      privacy: "Privacy",
      terms: "Termini",
      admin: "Area Riservata",
      rights: "© 2026 Talent Hub. Tutti i diritti riservati.",
    },
    chat: {
      floatingLabel: "Scrivici",
      openLabel: "Apri chat",
      closeLabel: "Chiudi chat",
      title: "Ciao 👋",
      subtitle: "Come possiamo aiutarti? Rispondiamo entro 24 ore.",
      namePlaceholder: "Il tuo nome (opzionale)",
      emailPlaceholder: "La tua email",
      messagePlaceholder: "Scrivi il tuo messaggio…",
      send: "Invia",
      sending: "Invio…",
      successTitle: "Messaggio ricevuto ✅",
      successBody: "Grazie! Ti risponderemo alla tua email il prima possibile.",
      newMessage: "Scrivi un altro messaggio",
      invalidEmail: "Inserisci un'email valida.",
      emptyMessage: "Il messaggio non può essere vuoto.",
      error: "Errore nell'invio. Riprova tra un momento.",
    },
  },
  en: {
    nav: {
      how: "How It Works",
      players: "Players",
      scouts: "Scouts",
      showcase: "Showcase",
      contact: "Contact Us",
      join: "Waitlist",
    },
    hero: {
      overline: "PRE-LAUNCH // YOUTH FOOTBALL",
      line1: "FROM YOUR CLUB",
      line2: "TO THE BIG STAGE.",
      sub: "The digital showcase reserved for registered young footballers. Upload your highlight videos and get noticed by top talent scouts and academies.",
      ctaPrimary: "Join the Waitlist",
      ctaSecondary: "Email us",
      counterSuffix: "already on the waitlist",
      cardTag: "ROOKIE CARD // PREVIEW",
      cardName: "THE NEXT TALENT",
      cardYou: "It could be you",
      cardChips: ["Pos —", "Age —", "Club —"],
    },
    marquee: "TALENT HUB • THE YOUTH FOOTBALL SHOWCASE • DIGITAL SCOUTING • HD HIGHLIGHTS • REGISTERED PLAYERS & ACADEMIES • FUTURE STARS • ",
    how: {
      overline: "THE PATH",
      title: "Three moves to the big stage",
      chapters: [
        {
          n: "01",
          title: "Registration & Membership",
          body: "Sign-up is reserved for young players registered with a sports club. Every profile is real, verified, traceable.",
        },
        {
          n: "02",
          title: "Build your showcase",
          body: "Name, surname, age, club, position, height — and above all your highlight videos: full matches or the actions that matter.",
        },
        {
          n: "03",
          title: "Get noticed",
          body: "Talent scouts and professionals search for new prospects for youth teams and academies. Your next call starts here.",
        },
      ],
    },
    audiences: {
      overline: "TWO WORLDS, ONE PLATFORM",
      title: "Built for those who play and those who watch",
      tabPlayers: "For Players",
      tabScouts: "For Scouts",
      playersTitle: "Your showcase. Your talent.",
      playersBody: "Registered with a sports club? Talent Hub gives you a professional stage to show who you are, how you play and why you matter.",
      playersBenefits: [
        "Verified profile: club-registered players only",
        "Highlight videos of your best matches and actions",
        "Complete data sheet: age, position, height, club",
        "Direct visibility to scouts, academies and pro youth teams",
      ],
      scoutsTitle: "Talent, before anyone else.",
      scoutsBody: "A curated feed of club-registered youngsters with real data and real video. Fewer miles, more certainty.",
      scoutsBenefits: [
        "Advanced filters by age, position, height and region",
        "HD highlight videos to judge talent on the pitch",
        "Direct contact with the player's home club",
        "An always-updated scouting feed of rising talent",
      ],
    },
    showcase: {
      overline: "PROFILE PREVIEW",
      title: "This is how a talent will look",
      body: "A sample mock card: data, club and highlights at a single glance.",
      watch: "Watch highlights",
      save: "Save profile",
      saved: "Saved",
      mockDisclaimer: "Demo profile — real data arrives when the app launches",
      modalTitle: "Highlights coming soon",
      modalBody: "When the app launches, this is where you'll watch every talent's best matches and standout actions.",
      close: "Close",
    },
    highlights: {
      overline: "IN ACTION",
      title: "Youth football, like you've never seen it.",
      body: "A preview of how talents will showcase their skills on Talent Hub. Click any video to watch it full.",
      disclaimer: "Demo videos — your real highlights will be published at launch.",
      clips: [
        { title: "Bicycle-kick goal", tag: "Action", src: "/videos/goal.mp4", poster: "/videos/goal-poster.jpg" },
        { title: "Class dribbling", tag: "Skill", src: "/videos/skill.mp4", poster: "/videos/skill-poster.jpg" },
        { title: "One-on-one duel", tag: "Technique", src: "/videos/dribble.mp4", poster: "/videos/dribble-poster.jpg" },
      ],
    },
    faq: {
      overline: "FREQUENTLY ASKED",
      title: "Everything you want to know before joining.",
      body: "Answers to the most common questions about Talent Hub. Got more? Just write to us.",
      items: [
        {
          q: "Will Talent Hub be free?",
          a: "Yes. Joining the waitlist is free, and creating a basic profile at launch will be free for players. We may later introduce optional premium features (e.g. HD video slots, advanced analytics), but the core platform will stay accessible to everyone.",
        },
        {
          q: "How does club registration work?",
          a: "Talent Hub is reserved for young players already registered with a sports club. During sign-up we'll ask for your club's name and verify the connection — this keeps profiles real and protects both players and scouts.",
        },
        {
          q: "How do you protect minors' privacy?",
          a: "We handle minors' data in full compliance with GDPR and Italian law. For under-14s we require parental or guardian consent. Profiles are not public on the web: only verified scouts and clubs can access content through the platform.",
        },
        {
          q: "Who can see my profile and videos?",
          a: "Only talent scouts, sports clubs and academies verified by us. No profile is indexed on Google and no content is shared externally. Every player (or their guardian) can decide who can contact them and what to show.",
        },
        {
          q: "How do scouts contact me?",
          a: "Interested scouts first contact your registered sports club, which then informs the player or family. There is no unfiltered direct contact: the club stays at the centre of the process, just like in real football.",
        },
        {
          q: "When does the app launch?",
          a: "We are gauging interest through this waitlist before launching the official version. By signing up you'll be among the first notified when the app goes live, and you'll get priority access to create your profile.",
        },
      ],
    },
    waitlist: {
      overline: "STAY IN THE LOOP",
      title: "Be among the first on the pitch",
      sub: "Leave your email: we'll notify you at launch and you'll help us gauge real interest in Talent Hub.",
      emailPlaceholder: "Your email",
      roleLabel: "Who are you?",
      countryLabel: "Country",
      roles: {
        player: "Player",
        parent: "Parent",
        scout: "Scout / Agent",
        club: "Sports club",
        other: "Other",
      },
      submit: "Sign me up",
      sending: "Sending…",
      successTitle: "You're in!",
      successBody: "We'll let you know as soon as Talent Hub goes live. Meanwhile, spread the word.",
      alreadyTitle: "Already on the list",
      alreadyBody: "This email is already registered — see you at launch!",
      invalid: "Please enter a valid email address.",
      error: "Something went wrong. Please try again shortly.",
      copyLink: "Copy the link to share",
      copied: "Copied!",
      contactAlt: "Prefer to write to us directly?",
      counterLabel: "people already on the list",
    },
    footer: {
      claim: "The future of youth football starts here.",
      privacy: "Privacy",
      terms: "Terms",
      admin: "Admin Area",
      rights: "© 2026 Talent Hub. All rights reserved.",
    },
    chat: {
      floatingLabel: "Message us",
      openLabel: "Open chat",
      closeLabel: "Close chat",
      title: "Hi 👋",
      subtitle: "How can we help? We reply within 24 hours.",
      namePlaceholder: "Your name (optional)",
      emailPlaceholder: "Your email",
      messagePlaceholder: "Write your message…",
      send: "Send",
      sending: "Sending…",
      successTitle: "Message received ✅",
      successBody: "Thanks! We'll reply to your email as soon as possible.",
      newMessage: "Send another message",
      invalidEmail: "Please enter a valid email.",
      emptyMessage: "The message can't be empty.",
      error: "Sending failed. Please try again shortly.",
    },
  },
  es: {
    nav: {
      how: "Cómo funciona",
      players: "Jugadores",
      scouts: "Ojeadores",
      showcase: "Vitrina",
      contact: "Contáctanos",
      join: "Lista de espera",
    },
    hero: {
      overline: "PRELANZAMIENTO // FÚTBOL JUVENIL",
      line1: "DE TU CLUB",
      line2: "AL GRAN FÚTBOL.",
      sub: "La vitrina digital reservada a los jóvenes futbolistas fichados por un club. Sube tus vídeos de highlights y hazte notar por ojeadores y academias.",
      ctaPrimary: "Únete a la lista",
      ctaSecondary: "Escríbenos",
      counterSuffix: "ya en la lista de espera",
      cardTag: "ROOKIE CARD // AVANCE",
      cardName: "EL PRÓXIMO TALENTO",
      cardYou: "Podrías ser tú",
      cardChips: ["Puesto —", "Edad —", "Club —"],
    },
    marquee: "TALENT HUB • LA VITRINA DEL FÚTBOL JUVENIL • SCOUTING DIGITAL • HIGHLIGHTS HD • JUGADORES FICHADOS Y ACADEMIAS • FUTURAS ESTRELLAS • ",
    how: {
      overline: "EL CAMINO",
      title: "Tres pasos hacia el gran fútbol",
      chapters: [
        {
          n: "01",
          title: "Ficha y registro",
          body: "La inscripción está reservada a los jóvenes fichados por un club deportivo. Cada perfil es real, verificado y trazable.",
        },
        {
          n: "02",
          title: "Crea tu vitrina",
          body: "Nombre, apellido, edad, club, posición, altura — y sobre todo tus vídeos highlights: partidos completos o las jugadas que cuentan.",
        },
        {
          n: "03",
          title: "Hazte notar",
          body: "Ojeadores y profesionales buscan nuevos talentos para canteras y academias. Tu próxima llamada empieza aquí.",
        },
      ],
    },
    audiences: {
      overline: "DOS MUNDOS, UNA PLATAFORMA",
      title: "Diseñada para quien juega y para quien observa",
      tabPlayers: "Para jugadores",
      tabScouts: "Para ojeadores",
      playersTitle: "Tu vitrina. Tu talento.",
      playersBody: "¿Estás fichado en un club deportivo? Talent Hub te ofrece un espacio profesional para mostrar quién eres, cómo juegas y por qué cuentas.",
      playersBenefits: [
        "Perfil verificado: solo jugadores fichados en clubes",
        "Vídeos highlights de tus mejores partidos y jugadas",
        "Ficha completa: edad, posición, altura, club",
        "Visibilidad directa hacia ojeadores, academias y canteras pro",
      ],
      scoutsTitle: "El talento, antes que los demás.",
      scoutsBody: "Un feed curado de jóvenes ya fichados, con datos reales y vídeo verificado. Menos kilómetros, más certezas.",
      scoutsBenefits: [
        "Filtros avanzados por edad, posición, altura y región",
        "Vídeos highlights HD para valorar el talento en el campo",
        "Contacto directo con los clubes de origen",
        "Feed de scouting sobre los talentos emergentes, siempre actualizado",
      ],
    },
    showcase: {
      overline: "AVANCE DEL PERFIL",
      title: "Así se verá un talento",
      body: "Una tarjeta de ejemplo: datos, club y highlights de un vistazo.",
      watch: "Ver highlights",
      save: "Guardar perfil",
      saved: "Guardado",
      mockDisclaimer: "Perfil de demostración — los datos reales llegarán con el lanzamiento",
      modalTitle: "Highlights próximamente",
      modalBody: "Con el lanzamiento de la app aquí podrás ver los vídeos de los partidos y las mejores jugadas de cada talento.",
      close: "Cerrar",
    },
    highlights: {
      overline: "EN ACCIÓN",
      title: "El fútbol juvenil como nunca lo has visto.",
      body: "Un anticipo de cómo los talentos mostrarán sus cualidades en Talent Hub. Haz clic en un vídeo para verlo entero.",
      disclaimer: "Vídeos de demostración — tus highlights reales se publicarán en el lanzamiento.",
      clips: [
        { title: "Chilena a gol", tag: "Acción", src: "/videos/goal.mp4", poster: "/videos/goal-poster.jpg" },
        { title: "Regates de clase", tag: "Skill", src: "/videos/skill.mp4", poster: "/videos/skill-poster.jpg" },
        { title: "Uno contra uno", tag: "Técnica", src: "/videos/dribble.mp4", poster: "/videos/dribble-poster.jpg" },
      ],
    },
    faq: {
      overline: "PREGUNTAS FRECUENTES",
      title: "Todo lo que quieres saber antes de inscribirte.",
      body: "Respuestas a las preguntas más comunes sobre Talent Hub. Si tienes otras dudas, escríbenos.",
      items: [
        { q: "¿Talent Hub será gratis?", a: "Sí. Inscribirse en la lista de espera es gratis, y crear el perfil básico al lanzamiento será gratis para los jugadores. En el futuro podríamos introducir funciones premium opcionales, pero el núcleo de la plataforma seguirá siendo accesible para todos." },
        { q: "¿Cómo funciona el fichaje?", a: "Talent Hub está reservado a los jóvenes ya fichados en un club deportivo. Durante el registro te pediremos el nombre de tu club y verificaremos la asociación para garantizar perfiles reales y proteger a jugadores y ojeadores." },
        { q: "¿Cómo protegéis la privacidad de los menores?", a: "Tratamos los datos de los menores en pleno cumplimiento del RGPD y la normativa vigente. Para los menores de 14 años pedimos el consentimiento de un padre o tutor. Los perfiles no son públicos en la web: solo ojeadores y clubes verificados pueden acceder al contenido a través de la plataforma." },
        { q: "¿Quién puede ver mi perfil y mis vídeos?", a: "Solo ojeadores, clubes deportivos y academias verificados por nosotros. Ningún perfil se indexa en Google y ningún contenido se comparte fuera. Cada jugador (o su tutor) puede decidir en cualquier momento quién puede contactarle y qué mostrar." },
        { q: "¿Cómo me contactan los ojeadores?", a: "Los ojeadores interesados primero contactan al club deportivo de pertenencia, que a su vez informa al jugador o a la familia. No existe contacto directo sin filtro: el club se mantiene siempre en el centro del proceso, como en el fútbol real." },
        { q: "¿Cuándo se lanza la app?", a: "Estamos recogiendo interés con esta lista de espera antes de lanzar la versión oficial. Al inscribirte serás de los primeros en ser avisado en cuanto la app esté en línea, y recibirás acceso prioritario para crear tu perfil." },
      ],
    },
    waitlist: {
      overline: "MANTENTE AL DÍA",
      title: "Sé de los primeros en saltar al campo",
      sub: "Deja tu email: te avisaremos en el lanzamiento y nos ayudarás a medir el interés real por Talent Hub.",
      emailPlaceholder: "Tu email",
      roleLabel: "¿Quién eres?",
      countryLabel: "País",
      roles: {
        player: "Jugador",
        parent: "Padre / Madre",
        scout: "Ojeador / Agente",
        club: "Club deportivo",
        other: "Otro",
      },
      submit: "Inscríbeme",
      sending: "Enviando…",
      successTitle: "¡Estás dentro!",
      successBody: "Te avisaremos en cuanto Talent Hub esté en línea. Mientras tanto, corre la voz.",
      alreadyTitle: "Ya estás en la lista",
      alreadyBody: "Este email ya está registrado — ¡nos vemos en el lanzamiento!",
      invalid: "Introduce una dirección de email válida.",
      error: "Algo salió mal. Inténtalo de nuevo en un momento.",
      copyLink: "Copia el enlace",
      copied: "¡Copiado!",
      contactAlt: "¿Prefieres escribirnos directamente?",
      counterLabel: "personas ya en la lista",
    },
    footer: {
      claim: "El futuro del fútbol juvenil empieza aquí.",
      privacy: "Privacidad",
      terms: "Términos",
      admin: "Área Reservada",
      rights: "© 2026 Talent Hub. Todos los derechos reservados.",
    },
    chat: {
      floatingLabel: "Escríbenos",
      openLabel: "Abrir chat",
      closeLabel: "Cerrar chat",
      title: "Hola 👋",
      subtitle: "¿Cómo podemos ayudarte? Respondemos en 24 horas.",
      namePlaceholder: "Tu nombre (opcional)",
      emailPlaceholder: "Tu email",
      messagePlaceholder: "Escribe tu mensaje…",
      send: "Enviar",
      sending: "Enviando…",
      successTitle: "Mensaje recibido ✅",
      successBody: "¡Gracias! Te responderemos a tu email lo antes posible.",
      newMessage: "Escribir otro mensaje",
      invalidEmail: "Introduce un email válido.",
      emptyMessage: "El mensaje no puede estar vacío.",
      error: "Error al enviar. Inténtalo de nuevo en un momento.",
    },
  },
  de: {
    nav: {
      how: "So funktioniert's",
      players: "Spieler",
      scouts: "Scouts",
      showcase: "Showcase",
      contact: "Kontakt",
      join: "Warteliste",
    },
    hero: {
      overline: "PRE-LAUNCH // JUGENDFUSSBALL",
      line1: "VOM VEREIN",
      line2: "AUF DIE GROSSE BÜHNE.",
      sub: "Die digitale Showcase-Plattform für junge, im Verein gemeldete Fußballer. Lade deine Highlight-Videos hoch und werde von Scouts und Akademien entdeckt.",
      ctaPrimary: "Zur Warteliste",
      ctaSecondary: "Schreib uns",
      counterSuffix: "bereits auf der Warteliste",
      cardTag: "ROOKIE CARD // VORSCHAU",
      cardName: "DAS NÄCHSTE TALENT",
      cardYou: "Es könntest du sein",
      cardChips: ["Position —", "Alter —", "Verein —"],
    },
    marquee: "TALENT HUB • DIE SHOWCASE-PLATTFORM FÜR JUGENDFUSSBALL • DIGITALES SCOUTING • HD HIGHLIGHTS • VEREINSSPIELER & AKADEMIEN • FUTURE STARS • ",
    how: {
      overline: "DER WEG",
      title: "Drei Schritte auf die große Bühne",
      chapters: [
        { n: "01", title: "Anmeldung & Vereinsprüfung", body: "Die Anmeldung ist jungen Spielern vorbehalten, die bei einem Sportverein gemeldet sind. Jedes Profil ist echt, verifiziert und nachvollziehbar." },
        { n: "02", title: "Bau dein Showcase", body: "Name, Alter, Verein, Position, Größe — und vor allem deine Highlight-Videos: ganze Spiele oder die Szenen, die zählen." },
        { n: "03", title: "Werde entdeckt", body: "Scouts und Profis suchen neue Talente für Jugendteams und Akademien. Dein nächster Anruf beginnt hier." },
      ],
    },
    audiences: {
      overline: "ZWEI WELTEN, EINE PLATTFORM",
      title: "Für alle, die spielen und alle, die beobachten",
      tabPlayers: "Für Spieler",
      tabScouts: "Für Scouts",
      playersTitle: "Deine Bühne. Dein Talent.",
      playersBody: "Bei einem Sportverein gemeldet? Talent Hub gibt dir eine professionelle Bühne, um zu zeigen, wer du bist, wie du spielst und warum du zählst.",
      playersBenefits: [
        "Verifiziertes Profil: nur bei Vereinen gemeldete Spieler",
        "Highlight-Videos deiner besten Spiele und Aktionen",
        "Komplettes Datenblatt: Alter, Position, Größe, Verein",
        "Direkte Sichtbarkeit für Scouts, Akademien und Profi-Jugendteams",
      ],
      scoutsTitle: "Talent, bevor es alle sehen.",
      scoutsBody: "Ein kuratierter Feed junger, vereinsgemeldeter Spieler mit echten Daten und echten Videos. Weniger Kilometer, mehr Sicherheit.",
      scoutsBenefits: [
        "Erweiterte Filter nach Alter, Position, Größe und Region",
        "HD-Highlight-Videos, um Talente auf dem Platz zu bewerten",
        "Direkter Kontakt zum Heimverein des Spielers",
        "Immer aktueller Scouting-Feed über aufstrebende Talente",
      ],
    },
    showcase: {
      overline: "PROFIL-VORSCHAU",
      title: "So sieht ein Talent aus",
      body: "Eine Beispielkarte: Daten, Verein und Highlights auf einen Blick.",
      watch: "Highlights ansehen",
      save: "Profil speichern",
      saved: "Gespeichert",
      mockDisclaimer: "Demo-Profil — echte Daten kommen zum Launch",
      modalTitle: "Highlights folgen",
      modalBody: "Zum Launch der App wirst du hier die Spiele und besten Aktionen jedes Talents ansehen können.",
      close: "Schließen",
    },
    highlights: {
      overline: "IN AKTION",
      title: "Jugendfußball, wie du ihn noch nie gesehen hast.",
      body: "Ein Vorgeschmack darauf, wie Talente ihre Fähigkeiten auf Talent Hub zeigen werden. Klicke auf ein Video, um es ganz anzusehen.",
      disclaimer: "Demo-Videos — deine echten Highlights werden zum Launch veröffentlicht.",
      clips: [
        { title: "Fallrückzieher-Tor", tag: "Aktion", src: "/videos/goal.mp4", poster: "/videos/goal-poster.jpg" },
        { title: "Klasse-Dribbling", tag: "Skill", src: "/videos/skill.mp4", poster: "/videos/skill-poster.jpg" },
        { title: "Eins gegen eins", tag: "Technik", src: "/videos/dribble.mp4", poster: "/videos/dribble-poster.jpg" },
      ],
    },
    faq: {
      overline: "HÄUFIGE FRAGEN",
      title: "Alles, was du vor der Anmeldung wissen willst.",
      body: "Antworten auf die häufigsten Fragen zu Talent Hub. Weitere Fragen? Schreib uns einfach.",
      items: [
        { q: "Wird Talent Hub kostenlos sein?", a: "Ja. Der Beitritt zur Warteliste ist kostenlos, und die Erstellung eines Basisprofils zum Launch wird für Spieler kostenlos sein. Wir könnten später optionale Premium-Funktionen einführen, aber der Kern der Plattform bleibt für alle zugänglich." },
        { q: "Wie funktioniert die Vereinsmeldung?", a: "Talent Hub ist jungen Spielern vorbehalten, die bereits bei einem Sportverein gemeldet sind. Bei der Anmeldung fragen wir nach deinem Verein und prüfen die Zugehörigkeit — so bleiben Profile echt und Spieler wie Scouts geschützt." },
        { q: "Wie schützt ihr die Privatsphäre Minderjähriger?", a: "Wir behandeln die Daten Minderjähriger im vollen Einklang mit der DSGVO. Für unter 14-Jährige verlangen wir die Zustimmung eines Elternteils oder Vormunds. Profile sind nicht öffentlich im Web: Nur verifizierte Scouts und Vereine können über die Plattform darauf zugreifen." },
        { q: "Wer kann mein Profil und meine Videos sehen?", a: "Nur von uns verifizierte Scouts, Sportvereine und Akademien. Kein Profil wird auf Google indexiert und keine Inhalte werden extern geteilt. Jeder Spieler (oder sein Vormund) kann jederzeit entscheiden, wer ihn kontaktieren darf und was gezeigt wird." },
        { q: "Wie werden Scouts mich kontaktieren?", a: "Interessierte Scouts kontaktieren zuerst deinen gemeldeten Sportverein, der dann den Spieler oder die Familie informiert. Es gibt keinen ungefilterten Direktkontakt: Der Verein bleibt stets im Zentrum des Prozesses — wie im echten Fußball." },
        { q: "Wann startet die App?", a: "Wir sammeln über diese Warteliste Interesse, bevor wir die offizielle Version starten. Wenn du dich anmeldest, gehörst du zu den Ersten, die beim Launch informiert werden, und erhältst prioritären Zugang zur Profilerstellung." },
      ],
    },
    waitlist: {
      overline: "BLEIB AUF DEM LAUFENDEN",
      title: "Sei einer der Ersten auf dem Platz",
      sub: "Lass deine E-Mail hier: Wir informieren dich zum Launch und du hilfst uns, das echte Interesse an Talent Hub zu messen.",
      emailPlaceholder: "Deine E-Mail",
      roleLabel: "Wer bist du?",
      countryLabel: "Land",
      roles: {
        player: "Spieler",
        parent: "Elternteil",
        scout: "Scout / Agent",
        club: "Sportverein",
        other: "Andere",
      },
      submit: "Anmelden",
      sending: "Wird gesendet…",
      successTitle: "Du bist dabei!",
      successBody: "Wir melden uns, sobald Talent Hub online geht. Bis dahin: verbreite die Nachricht.",
      alreadyTitle: "Schon auf der Liste",
      alreadyBody: "Diese E-Mail ist bereits registriert — bis zum Launch!",
      invalid: "Bitte gib eine gültige E-Mail-Adresse ein.",
      error: "Etwas ist schief gelaufen. Bitte versuche es gleich noch einmal.",
      copyLink: "Link zum Teilen kopieren",
      copied: "Kopiert!",
      contactAlt: "Möchtest du uns lieber direkt schreiben?",
      counterLabel: "Personen bereits auf der Liste",
    },
    footer: {
      claim: "Die Zukunft des Jugendfußballs beginnt hier.",
      privacy: "Datenschutz",
      terms: "AGB",
      admin: "Admin-Bereich",
      rights: "© 2026 Talent Hub. Alle Rechte vorbehalten.",
    },
    chat: {
      floatingLabel: "Schreib uns",
      openLabel: "Chat öffnen",
      closeLabel: "Chat schließen",
      title: "Hallo 👋",
      subtitle: "Wie können wir helfen? Wir antworten innerhalb von 24 Stunden.",
      namePlaceholder: "Dein Name (optional)",
      emailPlaceholder: "Deine E-Mail",
      messagePlaceholder: "Schreib deine Nachricht…",
      send: "Senden",
      sending: "Wird gesendet…",
      successTitle: "Nachricht erhalten ✅",
      successBody: "Danke! Wir antworten dir so bald wie möglich per E-Mail.",
      newMessage: "Weitere Nachricht senden",
      invalidEmail: "Bitte gib eine gültige E-Mail-Adresse ein.",
      emptyMessage: "Die Nachricht darf nicht leer sein.",
      error: "Senden fehlgeschlagen. Bitte versuche es gleich noch einmal.",
    },
  },
};
